import { Socket } from 'socket.io-client';

export interface SocketMessage {
  data: unknown;
  success: boolean;
  errorCode?: string;
}

const socketMap: Record<string, Socket> = {};

export const getSocket = (token: string): Socket | undefined => {
  return socketMap[token];
};

export const setSocket = (token: string, socket: Socket) => {
  socketMap[token] = socket;
};

export const removeSocket = (token: string) => {
  delete socketMap[token];
};
